import { TableRecord } from './TableRecord'

export class AdminRecord extends TableRecord {
  public cloudAccountId?: string
  public cloudUserId?: string
  public sapAccountId?: string
  public sapContactId?: string
  public firstName?: string
  public lastName?: string
  public sub?: string
  public email?: string
  public role: number = 1
  lastUpdated?: string
}
